export default __webpack_public_path__ + "static/media/jayNicoleFit.9682003e.jpg";